import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createFundDisbursement,
  updateFundDisbursement,
  deleteFundDisbursement,
} from '../../api/finance/fundDisbursements';

export const useFundDisbursementMutations = (queryKey = ['fundDisbursements']) => {
  const queryClient = useQueryClient();

  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey, exact: false });
  };

  return {
    createMutation: useMutation({
      mutationFn: createFundDisbursement,
      onSuccess: invalidate,
    }),
    updateMutation: useMutation({
      mutationFn: updateFundDisbursement,
      onSuccess: invalidate,
    }),
    deleteMutation: useMutation({
      mutationFn: deleteFundDisbursement,
      onSuccess: invalidate,
    }),
  };
};

export default useFundDisbursementMutations;
